import { Box, makeStyles } from '@material-ui/core';
import { RefObject, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { ComponentAccordion } from '../../../../../components/ComponentAccordion';
import { SubComponent } from '../../../../../components/SubComponent';
import { VisibilityChecker } from '../../../../../components/VisibilityChecker';
import { usePrototypeInformationGraphContext } from '../../../../../PrototypeInformationGraphContext';
import { BusinessConcept as BusincessConceptType } from '../../../../../types';

type BusinessConceptProps = {
  name: string;
  parentRef: RefObject<HTMLDivElement>;
  businessConcepts: BusincessConceptType[];
};

const useStyles = makeStyles(
  () => ({
    root: {
      background: 'transparent',
      position: 'relative',
    },
    visibilityChecker: {
      position: 'absolute',
      top: 18,
      left: 0,
    },
    content: {
      width: '100%',
      flexDirection: 'column',
      display: 'flex',
      gap: '10px',
    },
  }),
  { name: 'BusinessConcept' },
);

export const BusinessConcept = ({
  name,
  parentRef,
  businessConcepts,
}: BusinessConceptProps) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(true);

  const { setVisibleBusinessConcepts } = usePrototypeInformationGraphContext();

  return (
    <Box className={classes.root}>
      <ComponentAccordion
        expanded={expanded}
        handleChange={() => setExpanded(old => !old)}
        label={name}
        handle={
          <Handle
            type="target"
            id={name}
            position={Position.Left}
            style={{
              top: 20,
              left: '-5px',
              visibility: 'hidden',
            }}
          />
        }
        visibilityChecker={
          <VisibilityChecker
            className={classes.visibilityChecker}
            id={name}
            setVisibleIds={setVisibleBusinessConcepts}
            parentRef={parentRef}
          />
        }
      >
        {businessConcepts.map(d => (
          <SubComponent key={d.name} label={d.name} />
        ))}
      </ComponentAccordion>
    </Box>
  );
};
